import { render } from "./videoAndTextTemplate.vue?vue&type=template&id=627594c6&scoped=true"
import script from "./videoAndTextTemplate.vue?vue&type=script&lang=js"
export * from "./videoAndTextTemplate.vue?vue&type=script&lang=js"

import "./videoAndTextTemplate.vue?vue&type=style&index=0&id=627594c6&lang=scss"
import "./videoAndTextTemplate.vue?vue&type=style&index=1&id=627594c6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627594c6"]])

export default __exports__